(() => {
  class BlackWeekend extends HTMLElement {
    connectedCallback() {
      this.startsAt = Number(this.dataset.startsAt) * 1000;
      this.endsAt = Number(this.dataset.endsAt) * 1000;
      this.refresh = this.update.bind(this);
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('pageshow', this.refresh);
      this.update();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('pageshow', this.refresh);
    }
    update() {
      clearTimeout(this.timer);
      let now = Date.now();
      // A draft preview can show all three phases without changing the sale.
      if (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') {
        const preview = new URLSearchParams(window.location.search).get('bw_preview');
        if (preview === 'upcoming') now = this.startsAt - 1000;
        if (preview === 'active') now = this.startsAt + 1000;
        if (preview === 'expired') now = this.endsAt;
      }
      const valid = Number.isFinite(this.startsAt) && Number.isFinite(this.endsAt) && this.startsAt < this.endsAt;
      const phase = !valid || now >= this.endsAt ? 'expired' : now < this.startsAt ? 'upcoming' : 'active';
      this.render(phase);
      if (phase === 'expired') return;
      const boundary = phase === 'upcoming' ? this.startsAt : this.endsAt;
      this.timer = setTimeout(this.refresh, Math.min(boundary - now + 100, 2147483647));
    }
    render(phase) {
      this.hidden = phase === 'expired';
      if (this.hasAttribute('data-store-banner')) {
        document.documentElement.toggleAttribute('data-black-weekend-visible', !this.hidden);
      }
      this.dataset.phase = phase;
      this.querySelectorAll('[data-phase-text]').forEach(node => {
        node.hidden = node.dataset.phaseText !== phase;
      });
    }
  }
  class BlackWeekendPrice extends BlackWeekend {
    render(phase) {
      this.dataset.phase = phase;
      this.querySelector('[data-bw-regular]').hidden = phase === 'active';
      this.querySelector('[data-bw-offer]').hidden = phase !== 'active';
    }
  }
  if (!customElements.get('heliconia-black-weekend')) customElements.define('heliconia-black-weekend', BlackWeekend);
  if (!customElements.get('heliconia-black-weekend-price')) customElements.define('heliconia-black-weekend-price', BlackWeekendPrice);
})();
